export const racialEthinicGroup = [
  {
    id: 'hispanicLatinx',
    name: 'hispanicLatinx',
    label: 'Hispanic/Latinx',
  },
  {
    id: 'blackAfricanAmerican',
    name: 'blackAfricanAmerican',
    label: 'Black/African American (not Hispanic or Latinx)',
  },
  {
    id: 'asianPacificIslanders',
    name: 'asianPacificIslanders',
    label: 'Asian American/Pacific Islanders/Asian (not Hispanic or Latinx)',
  },
  {
    id: 'nativeAmerican',
    name: 'nativeAmerican',
    label: 'Native American/American Indian/Alaska Native/Indegenous (not Hispanic or Latinx)',
  },
  {
    id: 'whiteCaucasian',
    name: 'whiteCaucasian',
    label: 'White/Caucasian (not Hispanic or Latinx)',
  },
  {
    id: 'multiRacial',
    name: 'multiRacial',
    label: 'Multi-Racial, 2+ races',
  },
  {
    id: 'noAnswer',
    name: 'noAnswer',
    label: 'Prefer not to answer',
  },
];

export const majorityOwnership = [
  {
    id: 'majorityHispanicLatinx',
    name: 'majorityHispanicLatinx',
    label: 'Hispanic/Latinx',
  },
  {
    id: 'majorityBlackAfricanAmerican',
    name: 'majorityBlackAfricanAmerican',
    label: 'Black/African American (not Hispanic or Latinx)',
  },
  {
    id: 'majorityAsianPacificIslanders',
    name: 'majorityAsianPacificIslanders',
    label: 'Asian American/Pacific Islanders/Asian (not Hispanic or Latinx)',
  },
  {
    id: 'majorityNativeAmerican',
    name: 'majorityNativeAmerican',
    label: 'Native American/American Indian/Alaska Native/Indegenous (not Hispanic or Latinx)',
  },
  {
    id: 'majorityWhiteCaucasian',
    name: 'majorityWhiteCaucasian',
    label: 'White/Caucasian (not Hispanic or Latinx)',
  },
  {
    id: 'majorityMultiRacial',
    name: 'majorityMultiRacial',
    label: 'Multi-Racial, 2+ races',
  },
];

export const boardOfDirectorsMapping: { [key: string]: string } = {
  communityMembersPercent: 'Community Members',
  hispanicLatinxPercent: 'Hispanic/Latinx',
  blackAfricanAmericanPercent: 'Black/African American (not Hispanic or Latinx)',
  asianPacificIslandersPercent: 'Asian American/Pacific Islanders/Asian (not Hispanic or Latinx)',
  nativeAmericanPercent: 'Native American/American Indian/Alaska Native/Indegenous (not Hispanic or Latinx)',
  whiteCaucasianPercent: 'White/Caucasian (not Hispanic or Latinx)',
  multiRacialPercent: 'Multi-Racial, 2+ races',
};
